/**
 * Line Item Sorting Utilities
 * 
 * Provides consistent alphanumeric sorting for line items across the application.
 * Matches backend implementation for Excel and PDF files.
 * 
 * Sort Order: Product Number (primary) -> Lot Number (secondary)
 * Uses lexicographic comparison (e.g., "001" comes before "1").
 */

interface SortableLineItem {
	productNumber?: string;
	caseUsageProductNumber?: string;
	lotNumber?: string;
	caseUsageLotNumber?: string;
}

const compareAlphanumeric = (a: string, b: string): number => {
	const strA = (a || '').toString();
	const strB = (b || '').toString();

	return strA.localeCompare(strB);
};

export const applySortingRules = (lineItems: SortableLineItem[]): SortableLineItem[] => {
	if (!lineItems || lineItems.length === 0) {
		return lineItems;
	}

	return [...lineItems].sort((a, b) => {
		const productA = a.productNumber || a.caseUsageProductNumber || '';
		const productB = b.productNumber || b.caseUsageProductNumber || '';
		const productComparison = compareAlphanumeric(productA, productB);

		if (productComparison !== 0) {
			return productComparison;
		}

		const lotA = a.lotNumber || a.caseUsageLotNumber || '';
		const lotB = b.lotNumber || b.caseUsageLotNumber || '';

		return compareAlphanumeric(lotA, lotB);
	});
};
